<template>
  <div>
    <div class="text-left">
      <div class="section-icon">😘</div>
    </div>

    <!-- block -->
    <div class="block mt-4">
      <h1>Some reasons to hire me (and not)</h1>
      <p class="mt-4">
        These two questions are a lot harder than it seems at first. I mean, I
        know I'm a good person and all, and we all know everyone has financial
        motivations for working, but to write these answers without sounding
        generic is damn hard! But ... let's give it a go.
      </p>
    </div>
    <!-- ./ block -->

    <!-- block -->
    <div class="block">
      <h2>Why should you hire me?</h2>
      <ul>
        <li>
          I'm eager to work with a team that appriciates effort, but also gives
          creative freedom when needed
        </li>
        <li>
          I have 2+ years of experience working remotely and I really enjoy it
        </li>
        <li>
          I've worked as a one-man-band where I had to handle everything from
          customers to the final product. I know my way around the full cycle
        </li>
        <li>
          I've worked in small companies without any kind of organization (no
          product manager, etc). I have organisational skills (scrum, planning)
        </li>
        <li>
          I've worked in large corporation where our IT department counted more
          than 100 people. I don't ever want to do that again - corporation in
          classical meaning (tens of hundreds of employees) - but it was a great
          learning experience
        </li>
        <li>
          I've co-built a startup. We got some investment money and worked our
          asses off for a year. Failed miserably, bankrupted and started from
          nothing again. Learned tons from it. Would do it again (just with a
          bigger financial safety net)
        </li>
        <li>
          I think we are a match made in heaven 😘
        </li>
      </ul>
    </div>
    <!-- ./ block -->

    <!-- block -->
    <div class="block">
      <h2>Why should you not hire me?</h2>
      <ul>
        <li>
          I am not your classical senior developer. I do not know everything by
          heart, but I know how to find missing pieces to assemble the big
          picture. I learned how to use documentation instead of remembering
          everything.
        </li>
        <li>
          I do not have a formal education in Computer Science. I've completed
          three years of University but I did not get my BA. I've passed all
          exams with flying colors, but in the end ... well, life got in the way
          🙂
        </li>
        <li>
          I think sometimes trial and error is the best aproach to things you
          don't know. Usually I advocate making informed decisions with data
          available, but sometimes you just have to brute-force it.
        </li>
        <li>
          I do not have a lot of experience with writing tests. Companies where
          I previously worked did not find a lot of added value in testing, so I
          hadn't had any opportunity with writing them. That being said, I do
          think features need to be QA'd. If it can be automated even better!
        </li>
      </ul>
    </div>
    <!-- ./ block -->
  </div>
</template>

<script>
export default {
  name: 'Reasons'
}
</script>

<style></style>
